import { createTheme } from '@material-ui/core/styles';

import GetCapital from '../Components/svg/GetCapital';

const base = {
  palette: {
    type: 'light',
    common: {
      black: '#222c34',
      grey: '#899CA4',
      white: '#FAFBFB',
      polar: '#E6F8F9',
      leaf: '#99E2E6',
      softCyan: '#93DBDF',
      lightGreen: '#E7F6F9',
      midnightBlue: '#1B3642',
    },
    primary: {
      main: '#00B7C1',
      dark: '#01A8B1',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#00B7C1',
      light: '#F2FEFF',
      lighter: '#FEFBF4',
      contrastText: '#1E3641',
    },
    success: {
      main: '#3FB139',
      light: '#ABE9B0',
      lighter: '#f2fcf3',
    },
    error: {
      main: '#D34343',
      light: '#EAB9BC',
      lighter: '#FFDEDE',
    },
    warning: {
      main: '#E19B01',
      light: '#FAEED3',
      lighter: '#FEF7E6',
    },
    info: {
      main: '#4173B0',
      light: '#A7D5F4',
      lighter: '#E7F5FF',
    },
    grey: {
      1000: '#8F98A3',
      main: '#dadada',
      lighter: '#FCFDFE',
      light: '#D8E5F0',
      dark: '#808E94',
      darker: '#465568',
      contrastText: '#1E3641',
    },
    blue: {
      dark: '#1E3641',
      light: '#D1EDEF',
      lighter: '#EAF9FA',
    },
    action: {
      hover: '#FCF6E9',
      selected: '#FAEED3',
      light: '#FAEED3',
      contrastText: '#1E3641',
    },
  },
  typography: {
    fontSize: 12,
    htmlFontSize: 14,
    fontFamily: 'Rubik',
    h1: {
      fontSize: 24,
      fontWeight: 500,
    },
    h2: {
      fontSize: 20,
      fontWeight: 500,
    },
    h3: {
      fontSize: 18,
      fontWeight: 500,
    },
    h4: {
      fontSize: 18,
    },
    h5: {
      fontSize: 16,
      fontWeight: 500,
    },
    h6: {
      fontSize: 12,
    },
    subtitle1: {
      fontSize: 16,
      fontWeight: 500,
      '@media (min-width: 0) and (max-width: 480px)': {
        lineHeight: 1.4,
      },
    },
    subtitle2: {
      fontSize: 11,
    },
    body1: {
      fontSize: 16,
    },
    body2: {
      fontSize: 14,
    },
    button: {
      textTransform: 'none',
    },
  },
  shadows: Array(25).fill('none'),
};

let theme = createTheme(base);
theme = {
  ...theme,
  overrides: {
    MuiPaper: {
      root: {
        color: theme.palette.blue.dark,
      },
    },
    MuiFormLabel: {
      root: {
        color: theme.palette.blue.dark,
      },
    },
    MuiInputBase: {
      input: {
        height: 45,
        padding: '0 14px 0 14px',
        fontSize: 14,
      },
    },
    MuiOutlinedInput: {
      root: {
        '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
          borderColor: theme.palette.primary.main,
        },
        '&.Mui-focused $notchedOutline': {
          borderWidth: '1px',
        },
      },
      input: {
        padding: '0 14px 0 14px',
        fontSize: 14,
        backgroundColor: theme.palette.grey.lighter,
      },
      inputAdornedStart: {
        paddingLeft: 10,
      },
      adornedEnd: {
        paddingRight: 0,
      },
      notchedOutline: {
        borderColor: theme.palette.grey.main,
      },
    },
    MuiFormHelperText: {
      contained: {
        margin: '8px 0',
      },
    },
    MuiCssBaseline: {
      '@global': {
        '@media (min-width: 481px)': {
          body: {
            backgroundColor: theme.palette.blue.dark,
            overflowY: 'auto',
            margin: 0,
          },
        },
        '@media (min-width: 0) and (max-width: 480px)': {
          body: {
            backgroundColor: '#ffffff',
            overflowY: 'auto',
            margin: 0,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          },
        },
        '*::-webkit-scrollbar': {
          width: '0.5em',
        },
        '*::-webkit-scrollbar-track': {
          '-webkit-box-shadow': `inset 0 0 6px ${theme.palette.grey.dark}`,
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: theme.palette.grey.dark,
        },
        'input::-webkit-outer-spin-button': {
          '-webkit-appearance': 'none',
          margin: 0,
        },
        'input::-webkit-inner-spin-button': {
          '-webkit-appearance': 'none',
          margin: 0,
        },
        'input[type=number]': {
          '-moz-appearance': 'textfield',
        },
        'input[type=password]': {
          '-webkit-text-stroke-width': '0.3em',
          'letter-spacing': '0.3em',
        },
      },
    },
    MuiCheckbox: {
      root: {
        alignSelf: 'flex-start',
      },
    },
    MuiMenuItem: {
      root: {
        '&:hover': {
          backgroundColor: `${theme.palette.action.hover} !important`,
        },
      },
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: `${theme.palette.warning.light} !important`,
        color: `${theme.palette.blue.dark} !important`,
        '& span': {
          '& p': {
            fontWeight: 500,
          },
        },
      },
    },
    MuiButton: {
      outlinedSecondary: {
        backgroundColor: '#ffffff',
      },
    },
  },
};

export const headerLogo = GetCapital;

export default {
  theme,
  headerLogo,
};
